import {useTranslation} from "react-i18next";
import {DeleteButton} from "../../../../components/buttons/DeleteButton";

export const RecipeFormTable = ({recipeData, onRemove}) => {

    const {t} = useTranslation('recipe');

    const handleRemove = (recipeItem) => {
        onRemove(recipeItem)
    }

    return (
        <table>
            <thead>
            <tr>
                <th className={'th'} rowSpan={2}>{t('products:title')}</th>
                <th className={'td center'} colSpan={6}>{t('common:cradle')}</th>
                <th className={'td center'} colSpan={6}>{t('common:kindergarten')}</th>
                <th className={'td'}/>
            </tr>
            <tr>
                <th className={'td center'}>{t('common:gross')}</th>
                <th className={'td center'}>{t('common:net')}</th>
                <th className={'td center'}>{t('allProteins')}</th>
                <th className={'td center'}>{t('allFat')}</th>
                <th className={'td center'}>{t('allCarbohydrates')}</th>
                <th className={'td center'}>{t('allEnergyValueKcal')}</th>
                <th className={'td center'}>{t('common:gross')}</th>
                <th className={'td center'}>{t('common:net')}</th>
                <th className={'td center'}>{t('allProteins')}</th>
                <th className={'td center'}>{t('allFat')}</th>
                <th className={'td center'}>{t('allCarbohydrates')}</th>
                <th className={'td center'}>{t('allEnergyValueKcal')}</th>
                <td className={'td center'}/>
            </tr>
            </thead>
            <tbody>
            {recipeData.productsList === null ? <></> : recipeData.productsList.map((recipeItem, index) => {
                return (
                    <tr key={index}>
                        <td className={'td'}> {recipeItem.product.title}</td>
                        <td className={'td center'}>{recipeItem.amountGrossCradle}</td>
                        <td className={'td center'}>{recipeItem.amountNetCradle}</td>
                        <td className={'td center'}>{recipeItem.proteinsCradle}</td>
                        <td className={'td center'}>{recipeItem.fatCradle}</td>
                        <td className={'td center'}>{recipeItem.carbohydratesCradle}</td>
                        <td className={'td center'}>{recipeItem.energyValueKcalCradle}</td>
                        <td className={'td center'}>{recipeItem.amountGross}</td>
                        <td className={'td center'}>{recipeItem.amountNet}</td>
                        <td className={'td center'}>{recipeItem.proteins}</td>
                        <td className={'td center'}>{recipeItem.fat}</td>
                        <td className={'td center'}>{recipeItem.carbohydrates}</td>
                        <td className={'td center'}>{recipeItem.energyValueKcal}</td>
                        <td className={'td'}><DeleteButton onClick={() => handleRemove(recipeItem)}/></td>
                    </tr>
                )
            })}
            <tr>
                <th className={'td'}>{t('sum')}</th>
                <th className={'td'}/>
                <th className={'td'}/>
                <th className={'td center'}>{recipeData.allProteinsCradle}</th>
                <th className={'td center'}>{recipeData.allFatCradle}</th>
                <th className={'td center'}>{recipeData.allCarbohydratesCradle}</th>
                <th className={'td center'}>{recipeData.allEnergyValueKcalCradle}</th>
                <th className={'td'}/>
                <th className={'td'}/>
                <th className={'td center'}>{recipeData.allProteins}</th>
                <th className={'td center'}>{recipeData.allFat}</th>
                <th className={'td center'}>{recipeData.allCarbohydrates}</th>
                <th className={'td center'}>{recipeData.allEnergyValueKcal}</th>
            </tr>
            </tbody>
        </table>
    )

}